import { computed, ref } from 'vue'
import supplierHttp from '@supplier/http/supplierHttp'
import { defineStore } from 'pinia'

import { SUPPLIER_API } from '@supplier/http/api-routes'

import { IMPORT_IN_PROGRESS_STORAGE_KEY, IMPORT_STATUS_POLL_MS } from '@supplier/consts'

function readFlag() {
  try {
    return Boolean(JSON.parse(localStorage.getItem(IMPORT_IN_PROGRESS_STORAGE_KEY)))
  } catch (error) {
    console.error(error)
    return false
  }
}

function writeFlag(value) {
  try {
    localStorage.setItem(IMPORT_IN_PROGRESS_STORAGE_KEY, JSON.stringify(Boolean(value)))
  } catch (error) {
    console.error(error)
  }
}

export const useSupplierImportStore = defineStore('supplier-import', () => {
  const status = ref(false)
  const total = ref(0)
  const imported = ref(0)
  const isFlagged = ref(readFlag())
  const previewCount = ref(null)
  const isLocked = computed(() => status.value || isFlagged.value)
  let timerId = null
  let requestId = 0
  let isStarted = false

  function setFlag(value) {
    isFlagged.value = value
    writeFlag(value)
  }

  function schedule() {
    clearTimeout(timerId)
    timerId = isLocked.value ? setTimeout(refresh, IMPORT_STATUS_POLL_MS) : null
  }

  async function refresh() {
    const currentRequestId = ++requestId
    clearTimeout(timerId)
    timerId = null
    try {
      const { data } = await supplierHttp.get(SUPPLIER_API.importProductsStatus)
      if (currentRequestId !== requestId) return
      status.value = Boolean(data?.status)
      total.value = Number(data?.total) || 0
      imported.value = Number(data?.imported) || 0
      setFlag(status.value)
    } catch {
      if (currentRequestId !== requestId) return
    }
    schedule()
  }

  function start() {
    if (isStarted) return
    isStarted = true
    refresh()
  }

  function markStarted() {
    setFlag(true)
    status.value = true
    refresh()
  }

  function setPreviewCount(count) {
    previewCount.value = count ?? null
  }

  function clearPreviewCount() {
    previewCount.value = null
  }

  return {
    status,
    total,
    imported,
    isLocked,
    previewCount,
    start,
    refresh,
    markStarted,
    setPreviewCount,
    clearPreviewCount,
  }
})
